import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "error", "value", "onBlur", "onChange", "getIsUngated", "isNotUsingTimePoints"];
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
// @ts-expect-error untyped
import { getTransferableProps } from './filterInputProps';
import PropTypes from 'prop-types';
// @ts-expect-error untyped
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
// @ts-expect-error untyped
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import { fromSimpleDateToMoment, fromMomentToSimpleDate
// @ts-expect-error untyped
} from '../../utilities/momentSimpleDateConversion';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import { useEffect, useRef, useState } from 'react';
import TimezoneToggle from './TimezoneToggle';
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import BetweenTimePoints from 'customer-data-filters/filterQueryFormat/operator/BetweenTimePoints';
import NotBetweenTimePoints from 'customer-data-filters/filterQueryFormat/operator/NotBetweenTimePoints';
import UpdateDateFilterWithTimezonesNotification from './UpdateDateFilterWithTimezonesNotification';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDateRangeInputMoment = props => {
  const {
      className,
      error,
      value: condition,
      onBlur,
      onChange,
      getIsUngated,
      isNotUsingTimePoints
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const {
    hasTimezones,
    field: fieldRecord
  } = condition;
  const isDateTimeOperator = fieldRecord && fieldRecord.type === DATE_TIME;
  const [showTimezoneToggle, setShowTimezoneToggle] = useState(false);
  useEffect(() => {
    if (hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && !hasTimezones && (condition.constructor === BetweenTimePoints || condition.constructor === NotBetweenTimePoints)) {
      setShowTimezoneToggle(false);
    } else {
      setShowTimezoneToggle(true);
    }
  }, [condition.constructor, getIsUngated, hasTimezones, isDateTimeOperator]);
  const [useUTC, setUseUTC] = useState(condition.value || !condition.field ? condition.value.isUTC() : condition.field.get('type') === DATE);
  const handleUpdateClick = () => {
    setUseUTC(false);
    if (!condition) {
      return;
    }
    setShowTimezoneToggle(false);
    const {
      value: startDate,
      highValue: endDate
    } = condition;
    if (I18n.moment.isMoment(startDate) && I18n.moment.isMoment(endDate)) {
      const timezoneConverter = I18n.moment.portalTz;
      onChange(syntheticEvent(condition.merge({
        value: timezoneConverter(startDate.format('YYYY-MM-DD')),
        highValue: timezoneConverter(endDate.format('YYYY-MM-DD'))
      })), {
        hasClickedUpdate: true
      });
    }
  };
  const onTimezoneChange = newUseUTC => {
    setUseUTC(newUseUTC);
    if (!condition) {
      return;
    }
    const {
      value: startDate,
      highValue: endDate
    } = condition;
    if (I18n.moment.isMoment(startDate) && I18n.moment.isMoment(endDate)) {
      const timezoneConverter = newUseUTC ? I18n.moment.utc : I18n.moment.portalTz;
      onChange(syntheticEvent(condition.merge({
        value: timezoneConverter(startDate.format('YYYY-MM-DD')),
        highValue: timezoneConverter(endDate.format('YYYY-MM-DD'))
      })));
    }
  };
  const onChangeLocal = evt => {
    if (hasRemoveTimezoneForDates(getIsUngated) && !hasTimezones) {
      const startDate = fromSimpleDateToMoment(evt.target.value.startDate, false);
      const endDate = fromSimpleDateToMoment(evt.target.value.endDate, false);
      onChange(syntheticEvent(condition.merge({
        value: startDate,
        highValue: endDate
      })));
    } else {
      const startDate = fromSimpleDateToMoment(evt.target.value.startDate, useUTC);
      const endDate = fromSimpleDateToMoment(evt.target.value.endDate, useUTC);
      onChange(syntheticEvent(condition.merge({
        value: startDate,
        highValue: endDate
      })));
    }
  };
  const prevIsOpen = useRef(isOpen);
  useEffect(() => {
    if (typeof onBlur === 'function' && isOpen === false && prevIsOpen.current === true) {
      onBlur();
    }
    prevIsOpen.current = isOpen;
  }, [isOpen, onBlur]);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const inputValue = {
    startDate: fromMomentToSimpleDate(condition.get('value')),
    endDate: fromMomentToSimpleDate(condition.get('highValue'))
  };
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder,
    className: transferableClassName,
    disabled,
    onKeyDown,
    onKeyPress,
    onKeyUp,
    readOnly
  } = transferableProps;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    className: className,
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIDateRange, {
        className: transferableClassName,
        "data-selenium-test": dataSeleniumTest,
        disabled: disabled,
        onChange: onChangeLocal
        // @ts-expect-error preserve behavior that existed while spreading props
        ,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onOpenChange: evt => setIsOpen(evt.target.value),
        placeholder: placeholder,
        readOnly: readOnly,
        value: inputValue
      }), showTimezoneToggle && /*#__PURE__*/_jsx(TimezoneToggle, {
        fieldType: condition.field ? condition.field.get('type') : undefined,
        getIsUngated: getIsUngated,
        isNotUsingTimePoints: isNotUsingTimePoints,
        onChange: onTimezoneChange,
        useUTC: useUTC
      }), showTimezoneToggle && !isNotUsingTimePoints && hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && /*#__PURE__*/_jsx(UpdateDateFilterWithTimezonesNotification, {
        onUpdateClick: handleUpdateClick,
        useUTC: useUTC
      })]
    })
  });
};
FilterOperatorDateRangeInputMoment.propTypes = {
  className: PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: FilterOperatorType.isRequired
};
export default FilterOperatorDateRangeInputMoment;